module.exports = __webpack_public_path__ + "img/0Q3B1891_L_Wood.15978ae5.jpg";